<template>
    <div>
        <SeccionesComponent
            v-if="! zona"
            @terminar="zonaSeleccionada"
        />

        <transition name="fade" mode="out-in">
            <SeleccionarAsientosRegionNormal
                v-if="zona && ! zona.tiene_plazas"
                :asientos="asientos"
                :datos_compradores="datos_compradores"
                :zona="zona"
                @volver="volver"
                @asientosSeleccionados="asientosSeleccionados"
                :disabled="bloqueando || disabled"
            />

            <SeleccionarAsientosRegionAnexa 
                v-if="zona && zona.tiene_plazas"
                :zona="zona"
                :abonado="abonado"
                @asientosSeleccionados="asientosSeleccionados"
                :disabled="bloqueando || disabled"
                @volver="volver"
            />
        </transition>
    </div>
</template>

<script>
    import SeccionesComponent from './SeleccionarAsientoConSecciones/SeccionesComponent.vue';
    import SeleccionarAsientosRegionNormal from "./SeleccionarAsientosConRegiones/SeleccionarAsientosRegionNormal.vue";
    import SeleccionarAsientosRegionAnexa from "./SeleccionarAsientosConRegiones/SeleccionarAsientosRegionAnexa.vue";

    export default {
        props: {
            disabled: {
                required: true,
                type: Boolean
            },
            changeSeat: {
                required: true,
                type: Number
            }
        },
        data() {
            return {
                zona: null,
                asientos: [],
                datos_compradores: [],
                bloqueando: false
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            },
            renovacion() {
                return !!this.$route.query.n_abonado_antiguo;
            }
        },
        methods: {
            zonaSeleccionada(zona) {
                this.zona = zona;
            },
            volver() {
                if (this.renovacion) {
                    this.$router.push({ name: 'front.abonos.nuevo.index', query: { region_id: this.zona.id, dni: this.abonado.dni, n_abonado_antiguo: this.abonado.n_abonado_antiguo } });
                }

                this.asientos = [];
                this.datos_compradores = [];
                this.zona = null;
            },
            asientosSeleccionados(datos_compradores_temp, asientos_temp) {
                this.datos_compradores = datos_compradores_temp;
                this.asientos = asientos_temp;
                this.bloquearAsientos();
            },
            bloquearAsientos() {
                this.bloqueando = true;

                var seats = [];

                this.asientos.forEach(abonado => {
                    if(abonado.asiento) {
                        seats.push({
                            seat: abonado.asiento.asiento,
                            row: abonado.asiento.fila,
                            zona_id: abonado.asiento.zona_id,
                        });
                    }                
                });

                var plazas = [];

                this.asientos.forEach(asiento => {
                    if(asiento.plaza) {
                        plazas.push({
                            id: asiento.plaza.id,
                            region_id: this.zona.id,
                            abonado_id: this.abonado ? this.abonado.id : null
                        });
                    }
                });

                let params = {
                    filters: {
                        sesion_id: null
                    },
                    zona_id: this.zona.id,
                    asientos: seats,
                    butacas: plazas
                }

                const cookie = this.$cookies.get('comunicados-track-id');

                if(cookie) {
                    params.token_comunicado = cookie;
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                    if(res.data.error) {
                        this.volver()
                        this.$toast.error('Butaca/s ocupada/s');
                    } else {
                        this.$emit('butacasBloqueadas', this.datos_compradores, this.asientos, this.zona, res.data.session_id)
                        sessionStorage.setItem('session_id', res.data.session_id);
                    }

                }).catch(error => {
                    this.volver();
                    this.$toast.error('Butaca/s elegida/s por otro usuario.');
                }).finally(() => {
                    this.bloqueando = false;
                });
            },
            bloquearRenovacionSinAsientos(datos_compradores, asientos) {
                this.datos_compradores = datos_compradores;
                this.asientos = asientos;
                this.bloquearAsientos();
            },
        },
        components: {
            SeccionesComponent, SeleccionarAsientosRegionNormal, SeleccionarAsientosRegionAnexa
        }
    }
</script>